import { all, call, delay, put, select, takeLatest } from "redux-saga/effects";
import { push } from "connected-react-router";
import JsonPatch from "fast-json-patch";
import cloneDeep from "lodash.clonedeep";
import { CREATE_USER,
  createUserFailure,
  createUserRequested,
  createUserSuccess,
  LINKEDIN_LOGIN,
  linkedinLoginFailure,
  linkedinLoginRequested,
  linkedinLoginSuccess,
  LOGIN_USER,
  loginUserFailure,
  loginUserRequested,
  loginUserSuccess,
  FETCH_USERS_BY_ROLE,
  fetchUsersByRoleFailure,
  fetchUsersByRoleRequested,
  fetchUsersByRoleSuccess,
  FETCH_USER_PROFILE,
  fetchUserProfileFailure,
  fetchUserProfileRequested,
  fetchUserProfileSuccess,
  INVITE_USER_ON_PLATFORM,
  inviteUserOnPlatformFailure,
  inviteUserOnPlatformRequested,
  inviteUserOnPlatformSuccess,
  SEARCH_USER_BY_KEYWORD,
  searchUserByKeywordFailure,
  searchUserByKeywordRequested,
  searchUserByKeywordSuccess,
  UPDATE_USER_PROFILE,
  updateUserProfile,
  updateUserProfileFailure,
  updateUserProfileRequested,
  updateUserProfileSuccess, CHECK_USER_EXISTS, checkUserExistsSuccess, checkUserExistsFailure,
  CHECK_USER_EXISTS_CLEAR, checkUserExistsClearSuccess, UPDATE_USER_PASSWORD,
  updateUserPasswordSuccess, updateUserPasswordFailure, updateUserPasswordRequested,
  REQUEST_USER, requestUserRequested, requestUserFailure, requestUserSuccess, CLEAR_USER_INFO } from "../actions/user-action-types";
import { toggleSnackBar } from "../actions/app-action-types";
import httpClient from "./http-client";
import UserRoles from "../utility/user-role";
import configureFirebase from "../config/configure-firebase";
import Pages from "../routes/pages.jsx";

export function* createUserHandler({ payload }) {
  yield put(createUserRequested());
 const state= yield select((state) => state?.user?.movingPlan);
  const user = {
    dateOfBirth: payload.dateOfBirth ?? null,
    title: payload.title ?? "",
    firstName: payload.firstName ? payload.firstName.capitalizeEachLetter() : "bemoved",
    middleName: payload.middleName ?? "",
    lastName: payload.lastName ? payload.lastName.capitalizeEachLetter() : "member",
    email: payload.email,
    phoneNumber: payload.phoneNumber,
    socialAccountNumber: "",
    meta: { avatar: payload.avatar ?? null },
    bemoved: [{
      from: {},
      moving: {
        movingDate:state?.movingDate
      },
      to: {},
      details: {
        adults: 0,
        children: {
          "0-4": 0,
          "5-12": 0,
          "13-17": 0,
        },
        petDetails: {
          havePets: false, pets: [],
        },
        vehicles: [],
      },
      howToMove: {
        myself: false,
        friends: false,
        professionalServices: false,
      },
      interestedIn: {
        moveNowPayLater: false,
        myNewNeighbourhood: false,
        sellingRentingMyProperty: false,
      },
      tasks: [],
      createdAt: new Date(),
    }],
    isPhoneVerified: true,
    isEmailVerified: payload.emailVerified,
    verificationId: payload.verificationId,
    serviceCard: "",
    movePayNowOrLater: false,
    role: payload.role,
    isProfileCompleted: false,
    isDeleted: false,
    completePercentage: {
      avatar: 0,
      pets: 0,
      vehicles: 0,
      household: 0,
      profile: 0,
    },
    businessInfo: {
      businessName: "",
      country: "",
      abnNumber: "",
      businessLocation: "",
      businessWebsite: "",
      primaryContactName: "",
      businessEmail: "",
      businessPhone: "",
      abnInfo: {
        Abn: "",
        AbnStatus: "",
        AbnStatusEffectiveFrom: "",
        Acn: "",
        AddressDate: "",
        AddressPostcode: "",
        AddressState: "",
        BusinessName: [],
        EntityName: "",
        EntityTypeCode: "",
        EntityTypeName: "",
        Gst: null,
        Message: "",
      },
      serviceAreas: [],
    },
    justBrowsing: payload.justBrowsing,
  };

  const request = {
    data: { payload: user },
    method: "POST",
    url: "/api/v1/users",
  };

  const {
    data, error,
  } = yield call(httpClient, request);

  if (error) {
    yield put(createUserFailure(error));
  } else {
    const auth = configureFirebase();
    const token = yield auth.currentUser.getIdToken(true);

    const userInfo = {
      ...user,
      identifier: data.details.id,
      holdForBusinessInfo: payload.holdForBusinessInfo,
      token,
    };

    yield put(createUserSuccess(userInfo));

    if (payload.navigate) {
      yield put(push("/home"));
    } else if (user.role === UserRoles.Customer) {
      const movingPlan = yield select((state) => state?.user?.movingPlan);
      const clonePlan = cloneDeep(movingPlan);
      const hasPlan = Object.keys(clonePlan).length > 0;
      const clonedUser = cloneDeep(userInfo);
      const requestBody = { ...clonedUser };

      if (hasPlan) {
        const hasBemoved = clonedUser.bemoved.length > 0;
        const clonedBemoved = hasBemoved ? cloneDeep(clonedUser.bemoved[0]) : {};

        requestBody.bemoved = [{
          ...clonedBemoved,
          from: clonePlan.movingFrom,
          to: clonePlan.movingTo,
          moving: clonePlan,
        }];
      }

      yield put(updateUserProfile(requestBody));
    }
  }
}

export function* fetchUserHandler({ payload }) {
  yield put(fetchUserProfileRequested());

  const request = {
    method: "GET",
    url: `/api/v1/users/${payload}`,
  };

  const {
    data, error,
  } = yield call(httpClient, request);

  if (error) {
    yield put(fetchUserProfileFailure(error));
  } else {
    yield put(fetchUserProfileSuccess(data.details));
  }
}

export function* loginHandler({ payload }) {
  yield put(loginUserRequested());

  const request = {
    method: "GET",
    params: { email: payload.email },
    url: "/api/v1/users",
  };

  const {
    data, error,
  } = yield call(httpClient, request);

  if (error) {
    yield put(loginUserFailure(error));
    yield put(toggleSnackBar("You are not a registered user. Please register on our platform to proceed."));
  } else {
    const auth = configureFirebase();
    const token = yield auth.currentUser.getIdToken(true);

    const [user] = data.details;
    console.log("token", token);
    yield put(loginUserSuccess({
      ...user,
      token,
    }));
    if (payload.navigate) {
      yield put(push("/home"));
    } else if (user.role === UserRoles.Customer) {
      const movingPlan = yield select((state) => state?.user?.movingPlan);
      const clonePlan = cloneDeep(movingPlan);
      const hasPlan = Object.keys(clonePlan).length > 0;
      const clonedUser = cloneDeep(user);
      const requestBody = { ...clonedUser };

      if (hasPlan) {
        const hasBemoved = clonedUser.bemoved.length > 0;
        const clonedBemoved = hasBemoved ? cloneDeep(clonedUser.bemoved[0]) : {};

        requestBody.bemoved = [{
          ...clonedBemoved,
          from: clonePlan.movingFrom,
          to: clonePlan.movingTo,
          moving: clonePlan,
        }];
      }

      yield put(updateUserProfile(requestBody));
    }
  }
}

export function* linkedinLoginHandler({ payload }) {
  yield put(linkedinLoginRequested());

  const request = {
    method: "GET",
    params: { code: payload.code },
    url: "/api/v1/auth/linkedin",
  };

  const {
    data, error,
  } = yield call(httpClient, request);

  if (error) {
    yield put(linkedinLoginFailure(error));
  } else {
    const user = {
      ...data.details,
      firstName: data.details.localizedFirstName,
      lastName: data.details.localizedLastName,
    };

    if (typeof payload.callBack === "function") {
      payload.callBack(user);
    }

    yield put(linkedinLoginSuccess(user));
  }
}

export function* updateProfileHandler({ payload }) {
  yield put(updateUserProfileRequested());
  const userData = yield select((state) => state?.user?.user);
  const updates = {
    ...userData,
    ...payload,
  };

  const result = JsonPatch.compare(userData, updates);

  const options = {
    message: "Information saved successfully",
    severity: "success",
  };

  if (result.length) {
    const request = {
      data: { payload: result },
      method: "PATCH",
      url: `/api/v1/users/${userData?.identifier}`,
    };

    const { error } = yield call(httpClient, request);

    if (error) {
      yield put(updateUserProfileFailure(error));
    } else {
      yield put(toggleSnackBar(options));
      yield put(updateUserProfileSuccess(updates));
    }
  } else {
    yield put(toggleSnackBar(options));
  }
}

export function* fetchUsersByRoleHandler({ payload }) {
  yield put(fetchUsersByRoleRequested());

  const request = {
    method: "GET",
    params: { role: payload },
    url: "/api/v1/fetch-by-user-role",
  };

  const {
    data, error,
  } = yield call(httpClient, request, false);

  if (error) {
    yield put(fetchUsersByRoleFailure(error));
  } else {
    yield put(fetchUsersByRoleSuccess(data.details));
  }
}

export function* inviteUserHandler({ payload }) {
  yield put(inviteUserOnPlatformRequested());

  const request = {
    data: payload,
    method: "POST",
    url: "/api/v1/notification/email",
  };

  const { error } = yield call(httpClient, request);

  if (error) {
    yield put(inviteUserOnPlatformFailure(error));
  } else {
    const options = {
      message: "Invitation has been sent successfully",
      severity: "success",
    };

    yield put(toggleSnackBar(options));
    yield put(inviteUserOnPlatformSuccess());
  }
}

export function* searchUserByKeywordHandler({ payload }) {
  yield put(searchUserByKeywordRequested());
  yield delay(200);

  const request = {
    method: "GET",
    params: payload,
    url: "/api/v1/properties/user-search",
  };

  const {
    data, error,
  } = yield call(httpClient, request, false);

  if (error) {
    yield put(searchUserByKeywordFailure(error));
  } else {
    yield put(searchUserByKeywordSuccess(data.details));
  }
}

export function* checkUserExistsHandler({ payload }) {
  const request = {
    method: "GET",
    url: `/api/v1/user-email-verification?email=${payload.email}`,
  };

  const {
    data, error,
  } = yield call(httpClient, request, false);

  if (error) {
    yield put(checkUserExistsFailure(error));
  } else {
    yield put(checkUserExistsSuccess(data.details));
  }
}

export function* clearUserExistsHandler() {
  yield put(checkUserExistsClearSuccess());
}

export function* updateUserPasswordHandler({ payload }) {
  yield put(updateUserPasswordRequested());
  const userData = yield select((state) => state?.user?.user);
  const email = userData?.email;
  const request = {
    data: {
      payload: {
        email,
        currentPassword: payload.currentPassword,
        newPassword: payload.newPassword,
      },
    },
    method: "POST",
    url: "/api/v1/update-password",
  };

  const {
    data, error,
  } = yield call(httpClient, request);

  if (error) {
    yield put(updateUserPasswordFailure(error));
  } else {
    yield put(updateUserPasswordSuccess(data.details));
  }
}

export function* requestUserHandler({ payload }) {
  yield put(requestUserRequested());

  const request = {
    method: "POST",
    data: {
      payload: {
        email: payload.email,
        role: payload.role,
        invitedBy: payload.invitedBy,
      },
    },
    url: `/api/v1/invite-user?userId=${payload.userId}`,
  };

  const {
    data, error,
  } = yield call(httpClient, request, false);

  if (error) {
    yield put(requestUserFailure(error));
  } else {
    yield put(requestUserSuccess(data));
  }
}

export function* clearUserInfoHandler() {
  yield put(push(Pages.LandingPage));
}

function* User() {
  yield all([
    takeLatest(CREATE_USER, createUserHandler),
    takeLatest(FETCH_USERS_BY_ROLE, fetchUsersByRoleHandler),
    takeLatest(FETCH_USER_PROFILE, fetchUserHandler),
    takeLatest(LINKEDIN_LOGIN, linkedinLoginHandler),
    takeLatest(LOGIN_USER, loginHandler),
    takeLatest(INVITE_USER_ON_PLATFORM, inviteUserHandler),
    takeLatest(UPDATE_USER_PROFILE, updateProfileHandler),
    takeLatest(SEARCH_USER_BY_KEYWORD, searchUserByKeywordHandler),
    takeLatest(CHECK_USER_EXISTS, checkUserExistsHandler),
    takeLatest(CHECK_USER_EXISTS_CLEAR, clearUserExistsHandler),
    takeLatest(UPDATE_USER_PASSWORD, updateUserPasswordHandler),
    takeLatest(REQUEST_USER, requestUserHandler),
    takeLatest(CLEAR_USER_INFO, clearUserInfoHandler),
  ]);
}

export default User;
